import { uapiConnection } from '../uapiConnection';
import { getFieldsByOperationQuery } from './getFieldsByOperation';
import type { FieldByOperationQueryResponse } from './apiTypes';

export interface FieldSearchDescriptor {
  id: string;
  name: string;
  operationId: string;
}

export interface FieldSearchIndex {
  [fieldUuid: string]: FieldSearchDescriptor;
}

interface FieldSearchOptions {
  partialNameSearch?: string;
  sortBy?: string;
  sortDirection?: string;
}

async function getFieldNamesBySingleOperation(
  operationId: string,
  searchOptions?: FieldSearchOptions
): Promise<FieldSearchIndex> {
  const response = (await uapiConnection(
    getFieldsByOperationQuery({
      operationId,
      ...searchOptions,
    })
  )) as FieldByOperationQueryResponse;

  if (!response.data) {
    return {};
  }

  const fields = response.data.withOperationFields?.harvestStats?.fields ?? [];

  const index: FieldSearchIndex = {};
  fields.forEach((field) => {
    index[field.id] = { id: field.id, name: field.name, operationId };
  });
  return index;
}

function fetchFieldsByOperations(
  operationIds: string[],
  searchOptions?: FieldSearchOptions
): Promise<FieldSearchIndex> {
  const requests = operationIds.map(id => getFieldNamesBySingleOperation(id, searchOptions));
  return Promise.all(requests).then(results =>
    Object.assign({}, ...results) as FieldSearchIndex
  );
}

export function requestFieldNamesByOperations(operationIds: string[]): Promise<FieldSearchIndex> {
  return fetchFieldsByOperations(operationIds);
}

export function searchFieldsByName(
  operationIds: string[],
  partialNameSearch: string
): Promise<FieldSearchIndex> {
  return fetchFieldsByOperations(operationIds, {
    partialNameSearch,
    sortBy: 'NAME',
    sortDirection: 'ASC',
  });
}
